import { TIME_UNITS } from '../constants';
export var getInterval = function getInterval(units) {
  return Object.keys(TIME_UNITS).find(function (key) {
    return TIME_UNITS[key] === units;
  });
};